// Timer.jsx
import React, { useEffect, useRef } from 'react';
import { useTimer } from 'react-timer-hook';

function Timer({
	expiryTimestamp,
	onExpire,
	pauseTimer,
	className,
	pad,
	// warning SFX (già presenti)
	warnCountdownFrom = 5,
	warnSfxEnabled = true,
	playWarn,
	// ⬇️ fine countdown
	playTimeUp,
	expireSfxEnabled = true,
}) {
	const pauseRef = useRef(pauseTimer);
	useEffect(() => { pauseRef.current = pauseTimer; }, [pauseTimer]);

	const warnEnabledRef = useRef(warnSfxEnabled);
	useEffect(() => { warnEnabledRef.current = warnSfxEnabled; }, [warnSfxEnabled]);

	const expireEnabledRef = useRef(expireSfxEnabled);
	useEffect(() => { expireEnabledRef.current = expireSfxEnabled; }, [expireSfxEnabled]);

	const lastWarnedSecondRef = useRef(null);
	const rootRef = useRef(null);

	const {
		totalSeconds,
		seconds,
		minutes,
		pause,
		resume,
		restart,
	} = useTimer({
		expiryTimestamp,
		onExpire: () => {
			// Se l’overlay è aperto: niente suono, niente onExpire
			if (pauseRef.current) return;

			if (expireEnabledRef.current) playTimeUp?.();

			// Call dell’handler applicativo
			onExpire?.();
		},
		interval: 20,
	});

	// Pause/Resume reattivi
	useEffect(() => {
		if (pauseTimer) pause();
		else resume();
	}, [pauseTimer, pause, resume]);

	// Restart su nuova domanda (resta in pausa se overlay aperto)
	useEffect(() => {
		if (expiryTimestamp instanceof Date && !isNaN(expiryTimestamp)) {
			lastWarnedSecondRef.current = null;        // reset warning
			restart(expiryTimestamp, !pauseRef.current);
		}
	}, [expiryTimestamp, restart]);

	// Warning 5..1
	useEffect(() => {
		if (pauseRef.current) return;
		if (!warnEnabledRef.current) return;
		if (typeof totalSeconds !== 'number') return;

		if (totalSeconds <= warnCountdownFrom && totalSeconds >= 1) {
			if (lastWarnedSecondRef.current !== totalSeconds) {
				lastWarnedSecondRef.current = totalSeconds;

				// SFX
				playWarn?.();

				// Pulse (sync col bip): restart animazione one-shot
				const el = rootRef.current;
				if (el && !window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches) {
					el.classList.remove('pulse');
					// forza reflow per ri-triggerare l'animation
					void el.offsetWidth;
					el.classList.add('pulse');
				}
			}
		}
	}, [totalSeconds, warnCountdownFrom, playWarn]);

	const isWarningActive =
		!pauseRef.current &&
		warnEnabledRef.current &&
		typeof totalSeconds === 'number' &&
		totalSeconds <= warnCountdownFrom &&
		totalSeconds >= 1;

	return (
		<div
			ref={rootRef}
			className={`game-timer ${className ?? ''} ${isWarningActive ? 'is-warning' : ''}`}
		>
			<div>
				<span className="timer-minutes">
					{String(minutes).padStart((pad || 2), '0')}:
				</span>
				<span>{String(seconds).padStart((pad || 2), '0')}</span>
			</div>
		</div>
	);
}

export default Timer;


